var apparelSorter = require('./lib/ApparelSorter');
module.exports = apparelSorter;